import { request } from "../api/_base";
import { FILTER, HOTWORDS, LINKS } from "../constants";

export const getSearchResult = async ({
  keyword,
  page,
  size,
  ip,
  type,
  time,
  searchtype,
  restype,
  line = 0,
}) => {
  if (keyword == null || keyword == undefined) {
    return null;
  }
  const params = {
    kw: keyword,
    page: page || 1,
    line,
    ip,
    site: "dalipan",
  };

  if (FILTER.type[type]) {
    params.category = FILTER.type[type].value;
  }
  if (FILTER.time[time]) {
    params.diffDay = FILTER.time[time].value;
  }
  if (FILTER.searchtype[searchtype]) {
    params.searchType = FILTER.searchtype[searchtype].value;
  }
  if (FILTER.restype[restype]) {
    params.resType = FILTER.restype[restype].value;
  }
  if (FILTER.size[size]) {
    if (FILTER.size[size].minSize) {
      params.minSize = FILTER.size[size].minSize;
    } else {
      params.minSize = 1;
    }
    if (FILTER.size[size].maxSize) {
      params.maxSize = FILTER.size[size].maxSize;
    } else {
      params.maxSize = 1099511627776;
    }
  }

  const data = await request({
    url: "/api/v1/pan/search",
    params,
    headers: {
      "X-Authorization": process.server ? "" : localStorage.getItem("token"),
    },
  });
  return data;
};

export const getRandomResources = async ({ ip, size = 10 }) => {
  return await request({
    url: "/api/v1/pan/query",
    params: {
      type: "random",
      size,
      ip,
    },
  });
};

export const getNewResources = async ({ ip, size = 10 }) => {
  return await request({
    url: "/api/v1/pan/query",
    params: {
      type: "new",
      size,
      ip,
    },
  });
};

export const getHotResources = async ({ ip, size = 10 }) => {
  return await request({
    url: "/api/v1/pan/query",
    params: {
      type: "views",
      size,
      ip,
    },
  });
};

export const getDownloadMostResources = async ({ ip, size = 10 }) => {
  return await request({
    url: "/api/v1/pan/query",
    params: {
      type: "download",
      size,
      ip,
    },
  });
};

export const getRecommendResources = async ({ ip, keyword }) => {
  if (keyword == null || keyword == undefined) {
    return null;
  }
  const index = keyword.lastIndexOf(".");
  if (index > -1) {
    keyword = keyword.slice(0, index);
  }
  return await request({
    url: "/api/v1/pan/recommend",
    params: {
      keyword,
      ip,
    },
  });
};

export const getDetail = async ({ id, size = 15, ip, type, parent }) => {
  return await request({
    url: "/api/v1/pan/detail",
    params: {
      id: id,
      size: size,
      ip,
      type,
      parent,
    },
    headers: {
      "X-Authorization": process.server ? "" : localStorage.getItem("token"),
    },
  });
};

export const getUrl = async ({ id }) => {
  return await request({
    url: "/api/v1/pan/detail/url",
    params: { id: id },
  });
};

export const checkUrlFromBaidu = async (data) => {
  return (
    (await request({
      url: "/api/v1/pan/checkUrlValidFromBaidu",
      params: { data },
    })) || {}
  );
};

export const getRecommandWords = async () => {
  return HOTWORDS;
};

export const getFriendLinks = async () => {
  return LINKS;
};

export const getAdsInfo = async () => {
  return await request({
    isPrefix: false,
    url: `https://res.hexiaotu.com/pan/config/ad.json`,
  });
};

export const getFooterAdsInfo = async () => {
  return await request({
    isPrefix: false,
    url: `https://res.hexiaotu.com/pan/config/ad_footer.json`,
  });
};

export const getKeywordAdsInfo = async () => {
  return await request({
    isPrefix: false,
    url: `https://res.hexiaotu.com/pan/config/ad_keyword.json`,
  });
};

export const getScriptAdsInfo = async () => {
  return await request({
    isPrefix: false,
    url: `https://res.hexiaotu.com/pan/config/ad_script.json`,
  });
};

export const getCopyContent = async () => {
  return await request({
    isPrefix: false,
    url: `https://res.hexiaotu.com/pan/config/copy.json`,
  });
};

export const getBlockedHistory = async () => {
  return await request({
    isPrefix: false,
    url: `https://res.hexiaotu.com/pan/config/history.json`,
  });
};

export const getGroupInfo = async () => {
  return await request({
    isPrefix: false,
    url: `https://res.hexiaotu.com/pan/config/group.json`,
  });
};

export const getFeisuxiaConfig = async () => {
  return await request({
    isPrefix: false,
    url: `https://dl.feisuxia.com/release/release.json`,
  });
};

export const getQrcodeInfo = async () => {
  return await request({
    isPrefix: false,
    url: `https://res.hexiaotu.com/pan/config/qrcode.json`,
  });
};
